/** Shared background image for the onboarding wizard overlay (no dedicated route). */
export const ONBOARDING_FLOW_BACKGROUND_IMAGE = '/assets/onboarding/onboarding-background.jpg';

const onboardingBackgroundImageSx = {
  backgroundImage: `url(${ONBOARDING_FLOW_BACKGROUND_IMAGE})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
} as const;

/**
 * Onboarding owns the full content area below the global header (no app side nav).
 * Keeps global header visible for platform chrome only.
 */
export const onboardingBelowHeaderInsets = {
  top: 'var(--atlas-global-header-height, 64px)',
  left: 0,
  right: 0,
  bottom: 0,
} as const;

/** Full-viewport background (e.g. AI Recommendation dev preview host). */
export const onboardingFlowBackgroundSx = {
  position: 'fixed',
  inset: 0,
  zIndex: (theme: { zIndex: { modal: number } }) => theme.zIndex.modal - 1,
  pointerEvents: 'none',
  overflow: 'hidden',
  ...onboardingBackgroundImageSx,
} as const;

/** Background below global header so nav chrome stays visible during onboarding. */
export const onboardingBelowHeaderBackgroundSx = {
  position: 'fixed',
  ...onboardingBelowHeaderInsets,
  zIndex: (theme: { zIndex: { modal: number } }) => theme.zIndex.modal - 1,
  pointerEvents: 'none',
  overflow: 'hidden',
  ...onboardingBackgroundImageSx,
} as const;
